import { useQuery, UseQueryResult } from 'react-query';
import {CORE_API_SUFFIX, dataFetch, DIGGER_API_SUFFIX} from '../../../axios/customAxios';
import { generateQueryKey } from '../../../constants/hookConstants';
import { ApiError, ApiResponse } from '../../../interfaces/apiResponse.type';


const useGetCustomFields = (
    identifier: string,
): UseQueryResult<ApiResponse<any>, ApiError<any>> => {
    const queryParams = new URLSearchParams();

    const queryKey = generateQueryKey(identifier, queryParams);

    return useQuery<ApiResponse<any>, ApiError<any>>(
        [`custom_data_${queryKey}`],
        () => dataFetch.get(`${CORE_API_SUFFIX}custom-fields`),
    );
};

export default useGetCustomFields;
